import { makeConfigUrls as makeConfigUrlsJobsV2 } from 'hb-react/frontoffice/apps/JobsV2/utils';
import * as PostTypes from 'hb-react/frontoffice/apps/LiveFeed/constants/PostTypes';
import { getPaths as getProjectDetailsPaths } from 'hb-react/frontoffice/apps/ProjectDetails/utils/getPaths';

export const editItems = ({
  postType,
  navigate,
  currentUser,
  item,
  handleOpenEditModal,
}: {
  currentUser: { id: number };
  handleOpenEditModal: () => void;
  item: { id: number; topic_id: number | null, type: string; };
  navigate: (string) => void;
  postType: string;
}) => {
  if (postType === PostTypes.EVENT) {
    navigate(Routes.user_edit_user_event_path(currentUser.id, item.id));
  } else if (item.type === 'ventures_venture') {
    const projectDetailsPaths = getProjectDetailsPaths({
      currentUserId: currentUser.id,
      ventureId: item.id,
      topicId: item.topic_id,
    });

    navigate(projectDetailsPaths.edit);
  } else if (item.type === 'business_opportunities_request') {
    const opportunityUrls = makeConfigUrlsJobsV2({ currentUser });

    navigate(opportunityUrls.editItem({ opportunityId: item.id }));
  } else {
    handleOpenEditModal();
  }
};
